//import { trigger, state, style, transition, animate } from '@angular/core';
import { trigger, query, stagger,style, transition, animate,state, group} from '@angular/animations';
import { reduce } from 'rxjs/operators';
export const slideIn = trigger('slideIn',[
    transition(':enter', [
        query('*', style({ opacity: 0, transform: 'translateY(-100%)' })),
        query('*', stagger('20ms', [
          animate('.1s ease-in', style({ opacity: 1, transform: 'translateY(0)'}))
          ]))
        ])
])


export const openClose =  trigger('openClose', [

  state('*', style({

  })),
  transition(':enter', [
    style({
      transform: 'translateX(100%)',
      opacity: 0,
      background: 'linear-gradient(to right, #fffee7, #fffee7)'
    }),
    animate('.5s ease-in-out', style({
      transform: 'translateX(0)',
      opacity: 1
    }))
  ]),
  transition(':leave', [
    animate('.0s', style({
      transform: 'translateX(10%)',
      opacity: 1
    })),
  ]),
  transition('0 <=> 1', animate('10000ms ease'))
])

//quiz animations
export const quizAnimation = 
    trigger('quizAnimation', [
      state('inactive', style({
        boxShadow: '0 1px 3px #aaa',
        border: '1px solid grey',
        padding: '15px'
      })),
      state('active',   style({
        boxShadow: '0 2px 5px #aaa',
        border: '1px solid green',
        padding: '0'
      })),
      transition('inactive => active', animate('200ms ease-in')),
      transition('active => inactive', animate('200ms ease-out'))
    ])
  

    export const SlideInOutAnimation = [
      trigger('slideInOut', [
          state('in', style({
              'max-height': '500px', 'opacity': '1', 'visibility': 'visible'
          })),
          state('out', style({
              'max-height': '0px', 'opacity': '0', 'visibility': 'hidden'
          })),
          transition('in => out', [group([
              animate('400ms ease-in-out', style({
                  'opacity': '0'
              })),
              animate('600ms ease-in-out', style({
                  'max-height': '0px'
              })),
              animate('700ms ease-in-out', style({
                  'visibility': 'hidden'
              }))
          ]
          )]),
          transition('out => in', [group([
              animate('1ms ease-in-out', style({
                  'visibility': 'visible'
              })),
              animate('600ms ease-in-out', style({
                  'max-height': '500px'
              })),
              animate('800ms ease-in-out', style({
                  'opacity': '1'
              }))
          ]
          )])
      ]),
  ]


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/studentreport/animation.ts